export const columnasSolicitudes = [
  {
    key: "nDeSolicitud",
    label: "N° de solicitud",
    sorted: false,
    fixed: false,
    type: "link",
    hidden: false,
  },
  {
    key: "fecha",
    label: "Fecha",
    sorted: true,
    fixed: false,
    type: "date",
    hidden: false,
  },
  {
    key: "tipo",
    label: "Tipo",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "medioDePago",
    label: "Medio De Pago",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: true,
  },
  {
    key: "importeFormateado",
    label: "Importe",
    sorted: true,
    fixed: false,
    type: "number",
    hidden: false,
    sortKey: "currency"
  },
  {
    key: "estado",
    label: "Estado",
    sorted: true,
    fixed: false,
    type: "string",
    hidden: false,
  },
  {
    key: "abonado",
    label: "Abonado",
    sorted: false,
    fixed: false,
    type: "string",
    hidden: false
  },
  {
    key: "autorizante",
    label: "Autorizantes",
    sorted: false,
    fixed: false,
    type: "component",
    hidden: false
  },
  {
    key: "comentario",
    label: "",
    sorted: false,
    fixed: false,
    type: "component",
    hidden: false,
    tooltip: 'Comentarios de tu solicitud',
    tooltipPosition: 'bottom-end'
  },
  {
    key: "acciones",
    label: "",
    sorted: false,
    fixed: false,
    type: "link",
    hidden: false,
  }
];
